module.exports = __webpack_public_path__ + "static/img/bottom-line.d71789f9.png";